import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import ModalEnquiry from './ModalEnquiry';

export default function Training({ setHideEnquire }) {
  const [open, setOpen] = useState(false);

  React.useEffect(() => {
    if (setHideEnquire) setHideEnquire(true);
    return () => { if (setHideEnquire) setHideEnquire(false); };
  }, [setHideEnquire]);

  return (
    <section id="train" className="py-24 px-6 md:px-8" style={{ backgroundColor: 'var(--bg-subtle)' }}>
      <div className="container-premium flex flex-col md:flex-row items-center gap-12">
        <motion.div
          className="md:w-1/2"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          <div className="eyebrow mb-4">Trainings</div>
          <h2 className="t-h1 font-display mb-6" style={{ color: 'var(--text-primary)' }}>
            Learn. Build. Get Paid.
          </h2>
          <p className="t-body mb-8" style={{ color: 'var(--text-secondary)' }}>
            Selected candidates are trained in prompt engineering and AI-assisted software design.
            Strong performers are onboarded onto paid delivery teams.
          </p>
          <div className="flex flex-wrap gap-4">
            <button className="btn btn-primary" onClick={() => setOpen(true)}>
              Enquire Now
            </button>
            <Link to="/trainings" className="btn btn-secondary">
              See Full Curriculum
            </Link>
          </div>
        </motion.div>
        <motion.div
          className="md:w-1/2 flex justify-center items-center"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <div className="card w-full max-w-sm aspect-square flex items-center justify-center relative overflow-hidden">
            <div className="ai-orb w-64 h-64" style={{ opacity: 0.25 }} />
            <FontAwesomeIcon
              icon={faGraduationCap}
              className="relative z-10 text-8xl"
              style={{ color: 'var(--accent)' }}
            />
          </div>
        </motion.div>
      </div>
      <ModalEnquiry open={open} onClose={() => setOpen(false)} triggerLabel="Enquire About Trainings" />
    </section>
  );
}
